export default __webpack_public_path__ + "static/media/extrenal-link-blue.53a90387.svg";